import { render, staticRenderFns } from "./PackageManager.vue?vue&type=template&id=7e8d841b&"
import script from "./PackageManager.vue?vue&type=script&lang=js&"
export * from "./PackageManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports